import React, {useEffect} from 'react'
import NodeOnlineRate from './node-online-rate'
import EnergyOnline from './energy-online'
import DeviceOnline from './device-online'
import ProgramList from './program-online'
import RealtimeMonitor from './realtime-monitor'
import IndexChart from './index-chart'
import MonitorOnline from './monitor-online'
import Client from './client'
import InformationInfo from './InformationInfo'
import swiperBg from '@assets/img/swiperBg.png'
import homeJump from '@assets/img/homeJump.png'
import './index.less'

export default function CockpitIndex() {
  return (
    <React.Fragment>
      <img src={swiperBg} className='ck-index-img'/>
      <div className='ck-index-item'>
        <div className='ck-index-top'>
          <div className='ck-index-left'>
            <DeviceOnline/>
            <ProgramList/>
            <NodeOnlineRate/>
          </div>
          <div className='ck-index-center'>
            <IndexChart />
          </div>
          <div className='ck-index-right'>
            <MonitorOnline/>
            <EnergyOnline/>
          </div>
        </div>
        <div className='ck-index-bottom'>
          <Client/>
          <InformationInfo/>
          <RealtimeMonitor/>
        </div>
      </div>
      <img className='homeJump' src={homeJump} onClick={() => {window.location.href= "http://" + window.location.hostname + ":20005/manage/home"}}/>
    </React.Fragment>
  )
}
